export const LYMPH_NAMES = {
  "Lymph_nodes_L": { english: "Superficial Lymph Nodes — Left (Cervical, Axillary & Inguinal Groups)", latin: "Nodi Lymphatici Superficialis Sinistri" },
  "Lymph_nodes_R": { english: "Superficial Lymph Nodes — Right (Cervical, Axillary & Inguinal Groups)", latin: "Nodi Lymphatici Superficialis Dextri" },
  "Lymph_nodes02": { english: "Deep Lymph Node Chain (Thoracic, Abdominal & Pelvic Groups)", latin: "Nodi Lymphatici Profundi (Thoracici, Abdominales, Pelvici)" },
  "Lymph_vessel_L": { english: "Lymphatic Vessels — Left (Draining to Thoracic Duct)", latin: "Vasa Lymphatica Sinistra (ad Ductum Thoracicum)" },
  "Lymph_vessel_R": { english: "Lymphatic Vessels — Right (Draining to Right Lymphatic Duct)", latin: "Vasa Lymphatica Dextra (ad Ductum Lymphaticum Dexter)" },
  "Spleen": { english: "Spleen — Largest Lymphoid Organ", latin: "Lien (Splen)" },
  "Thymus": { english: "Thymus — Primary Lymphoid Organ (T-cell Maturation)", latin: "Thymus" },
  "Thymus_001": { english: "Thymus — Primary Lymphoid Organ (T-cell Maturation)", latin: "Thymus" },
  "Thyroid": { english: "Thyroid Gland", latin: "Glandula Thyroidea" }
};

const LYMPH_KEYS = Object.keys(LYMPH_NAMES);

function fuzzyMatch(name) {
  if (!name) return null;
  if (LYMPH_NAMES.hasOwnProperty(name)) return name;

  const normalized = name.trim();
  for (const key of LYMPH_KEYS) {
    if (key.trim() === normalized) return key;
  }

  const lower = normalized.toLowerCase().replace(/\s+/g, ' ');
  for (const key of LYMPH_KEYS) {
    if (key.toLowerCase().replace(/\s+/g, ' ') === lower) return key;
  }

  return null;
}

function isKnownLymphName(name) {
  return fuzzyMatch(name) !== null;
}

export function resolveLymphName(mesh) {
  if (!mesh) return null;

  const meshName = mesh.name || '';
  const matName = mesh.material?.name || '';
  const parentName = mesh.parent?.name || '';

  if (meshName) { const match = fuzzyMatch(meshName); if (match) return match; }
  if (matName) { const match = fuzzyMatch(matName); if (match) return match; }
  if (parentName) { const match = fuzzyMatch(parentName); if (match) return match; }

  let ancestor = mesh.parent;
  while (ancestor) {
    if (ancestor.name) { const match = fuzzyMatch(ancestor.name); if (match) return match; }
    ancestor = ancestor.parent;
  }

  if (meshName.length > 0) return meshName;
  if (matName.length > 0) return matName;

  return null;
}

export function getLymphInfo(meshName) {
  if (!meshName) return { english: "Unknown Structure", latin: "Incertum" };

  const matched = fuzzyMatch(meshName);
  if (matched && LYMPH_NAMES[matched]) return LYMPH_NAMES[matched];

  let clean = meshName.replace(/_/g, ' ').replace(/\d+$/, '').trim();
  return { english: clean, latin: clean };
}
